import type {
  HeatmapWidgetEntity,
  THeatmapSerializedInternalState,
} from 'src/pages/dashboard/features/heatmap-widget/HeatmapWidget.entity';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function serializeHeatmapTemplate(widget: HeatmapWidgetEntity): TSerializedWidgetTemplate {
  const internalState: THeatmapSerializedInternalState = {
    wellId: null,
    stateParams: widget.stateParams,
  };

  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
